
define('text!modules/core/templates/app.hbs',[],function () { return '<div>\n    <div id="pageContent"></div>\n</div>';});

